import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLanguage } from '../../Context/LanguageContext'

const languageNames = {
  en: 'English',
  ar: 'العربية',
  fa: 'فارسی',
}

const languageFlags = {
  en: '🇬🇧',
  ar: '🇸🇦',
  fa: '🇮🇷',
}

const LanguageSwitcher = ({ variant = 'header', onSelect }) => {
  const { language, changeLanguage, supportedLanguages } = useLanguage()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLanguageChange = (lang) => {
    changeLanguage(lang)
    setIsOpen(false)
    onSelect?.()
  }

  const triggerClass =
    variant === 'mobile'
      ? 'imigo-lang-trigger imigo-lang-trigger--mobile'
      : 'imigo-lang-trigger imigo-lang-trigger--header'

  const menuClass =
    variant === 'mobile'
      ? 'imigo-lang-menu imigo-lang-menu--mobile'
      : 'imigo-lang-menu imigo-lang-menu--header'

  return (
    <div className={`imigo-lang-switcher ${variant === 'mobile' ? 'imigo-lang-switcher--mobile' : ''}`} ref={dropdownRef}>
      <button
        type="button"
        className={triggerClass}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
        aria-expanded={isOpen}
      >
        <span className="imigo-lang-flag">{languageFlags[language]}</span>
        <span className="imigo-lang-label">{languageNames[language]}</span>
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`} aria-hidden="true" />
      </button>

      {isOpen && (
        <div className={menuClass} role="menu">
          {supportedLanguages.map((lang) => (
            <button
              key={lang}
              type="button"
              role="menuitem"
              className={`imigo-lang-option ${language === lang ? 'is-active' : ''}`}
              onClick={() => handleLanguageChange(lang)}
            >
              <span className="imigo-lang-flag">{languageFlags[lang]}</span>
              <span>{languageNames[lang]}</span>
              {language === lang && <i className="fas fa-check" aria-hidden="true" />}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

LanguageSwitcher.propTypes = {
  variant: PropTypes.oneOf(['header', 'mobile']),
  onSelect: PropTypes.func,
}

export default LanguageSwitcher
